import VueI18n from "vue-i18n";
import {en, he, pt} from "./lang";
// import pr from "./pr";
import Vue from "vue";

Vue.use(VueI18n);

export function getSystemLang() {
	return document.documentElement.lang;
}

export function isRtl() {
	return document.documentElement.lang === "he";
}


export const i18n = new VueI18n({
	locale: document.documentElement.lang || "he", // set locale
	messages: {
		he,
		en,
		pt
	}, // set locale messages
});

export default i18n;
